import React, { useState } from 'react';
import Login from './login';
import FileList from './components/FileList';
import ImageList from './components/ImageList';
import './styles.css'; // This path is correct

const App = () => {
  const [token, setToken] = useState(null);
  const [role, setRole] = useState(null);

  if (!token) {
  return <Login onLogin={(t, r) => { setToken(t); setRole(r); }} />;
  }

  return (
    <div className="app-container">
      <h1 className="main-title">Content Management System</h1>
      <div className="dashboard-grid">
        <FileList />
        <ImageList />
      </div>
    </div>
  );
};

export default App;